import React from 'react';
import PortfolioContainer from './components/PortfolioContainer';

const App = () => <PortfolioContainer />;

export default App;
